angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-participant-factory',
        function ($api, $factory) {
            $api.factory.participant = $factory;
        },
    ])
    .factory('graph-participant-factory', [
        'graph-api-client',
        function (client) {
            function Participants(entry, id, term) {
                if (term === undefined) term = 'participants';

                this.query = function (options) {
                    return client.get([entry, id, term], options);
                };

                this.update = function (user_id, data, options) {
                    return client.post([entry, id, 'participant', user_id], data, options);
                };

                this.delete = function (user_id, options) {
                    return client.delete([entry, id, 'participant', user_id], options);
                };

                this.join = function (options) {
                    return client.post([entry, id, term], undefined, options);
                };

                this.inviteCreateUser = function (data) {
                    // entry = "group" - most likely
                    return client.post([entry, id, 'invite-create-user'], data);
                };

                this.leave = function (options) {
                    return client.delete([entry, id, term], options);
                };

                this.expire = function (user_id, data, options) {
                    return client.post([entry, id, 'participant', user_id, 'expire'], data, options);
                };

                this.remove = function (user_id, options) {
                    return client.delete([entry, id, 'participant', user_id, 'remove'], options);
                };

                this.ownership = function (options) {
                    return client.get([entry, id, 'related', 'ownership'], options);
                };
            }

            return {
                entry: function (entry, id, term) {
                    return new Participants(entry, id, term);
                },
            };
        },
    ]);
